export default "/assets/no_content-904ad5a2a54beb476236ddda83ac6285216caf1855c80d211794e4279e2319c3.svg";